import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SidebarStateService {
  readonly collapsed = signal(false);
  readonly mobileOpen = signal(false);

  toggleCollapse(): void { this.collapsed.update(v => !v); }
  toggleMobile(): void   { this.mobileOpen.update(v => !v); }
  closeMobile(): void    { this.mobileOpen.set(false); }
}
